// EXPLORE & FIND — GLOBAL BEHAVIOUR
// Mobile menu, cart drawer (AJAX Cart API), quantity steppers, accordions, predictive search.

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var menu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (menu) menu.classList.toggle('is-open');
      document.body.style.overflow = menu && menu.classList.contains('is-open') ? 'hidden' : '';
    });
  });
  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (menu) menu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openCartDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  function renderCartDrawer(cart) {
    if (!drawer) return;
    var itemsWrap = drawer.querySelector('[data-cart-items]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var countEls = document.querySelectorAll('[data-cart-count]');

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (!cart.item_count) {
      itemsWrap.innerHTML = '<div class="cart-drawer__empty">Your bag is empty. Time to explore.</div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) footer.style.display = 'block';

    var html = cart.items.map(function (item) {
      return (
        '<div class="cart-line" data-cart-line="' + item.key + '">' +
          '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">' +
          '<div class="cart-line__info">' +
            '<div class="cart-line__title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '') +
            '<div class="cart-line__qty">' +
              '<button type="button" data-cart-qty-decrease>&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cart-qty-increase>+</button>' +
            '</div>' +
            '<div class="cart-line__remove" data-cart-remove>Remove</div>' +
          '</div>' +
          '<div>' + formatMoney(item.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');
    itemsWrap.innerHTML = html;

    itemsWrap.querySelectorAll('[data-cart-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLineQty(btn, 1); });
    });
    itemsWrap.querySelectorAll('[data-cart-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLineQty(btn, -1); });
    });
    itemsWrap.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.closest('[data-cart-line]').getAttribute('data-cart-line');
        updateCartLine(key, 0);
      });
    });

    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function changeLineQty(btn, delta) {
    var line = btn.closest('[data-cart-line]');
    var key = line.getAttribute('data-cart-line');
    var qtyEl = line.querySelector('.cart-line__qty span');
    var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);
    updateCartLine(key, newQty);
  }

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function (err) { console.error('Cart update failed', err); });
  }

  function formatMoney(cents) {
    return (window.themeMoneyFormat || '£{{amount}}').replace(
      '{{amount}}',
      (cents / 100).toFixed(2)
    );
  }

  // Intercept "add to cart" forms for AJAX add + open drawer
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCartDrawer(cart);
          openCartDrawer();
        })
        .catch(function (err) { console.error('Add to cart failed', err); })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });

  // Initial cart render on load so header count / drawer are correct
  fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer).catch(function () {});

  /* ---------- Quantity stepper (product page) ---------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-decrease]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
    wrap.querySelector('[data-qty-increase]').addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ---------- Accordion (product page: description / delivery / etc.) ---------- */
  document.querySelectorAll('[data-accordion-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-accordion-trigger]');
    trigger.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('[data-predictive-search-results]');
  var searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div class="predictive-search__empty">No products found.</div>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              return (
                '<a class="predictive-search__item" href="' + p.url + '">' +
                  (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                  '<span>' + p.title + '</span>' +
                  '<span class="predictive-search__price">' + p.price + '</span>' +
                '</a>'
              );
            }).join('');
          })
          .catch(function (err) { console.error('Predictive search failed', err); });
      }, 250);
    });
  }
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.querySelector('[data-search-panel]');
      if (panel) {
        panel.classList.toggle('is-open');
        if (panel.classList.contains('is-open')) searchInput && searchInput.focus();
      }
    });
  });
});
